export default __webpack_public_path__ + "static/media/croptop-small-front.2516471d.jpg";